/** 확정 표시는 상태 문구만 믿지 않고 최종 트리와 확인 게이트를 함께 확인한다. */
export function isProveFinal(result) {
  const tree = result?.classification_tree || result?.apparel_tree || {};
  return tree.action === "supported" && /^\d{10}$/.test(String(tree.supported_hsk || ""))
    && result?.comparison?.tree_may_override_legacy === true
    && result?.prove?.workflow?.final !== false
    && (!tree.product_fact_dialogue || tree.product_fact_dialogue.status === 'candidate_ready');
}
